// Auth
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';

export const SET_USER_ROLE_START = 'SET_USER_ROLE_START';
export const SET_USER_ROLE_SUCCESS = 'SET_USER_ROLE_SUCCESS';
export const SET_USER_ROLE_FAIL = 'SET_USER_ROLE_FAIL';

// Users
export const LIST_USERS_START = 'LIST_USERS_START';
export const LIST_USERS_SUCCESS = 'LIST_USERS_SUCCESS';
export const LIST_USERS_FAIL = 'LIST_USERS_FAIL';

export const CREATE_USER_START = 'CREATE_USER_START';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const DELETE_USER_START = 'DELETE_USER_START';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const CLEAR_USER_UPDATE_STATE = 'CLEAR_USER_UPDATE_STATE';
export const SET_USER_TO_UPDATE = 'SET_USER_TO_UPDATE';
export const SET_USER_TO_DELETE = 'SET_USER_TO_DELETE';

// Orgs
export const LIST_ORGS_START = 'LIST_ORGS_START';
export const LIST_ORGS_SUCCESS = 'LIST_ORGS_SUCCESS';
export const LIST_ORGS_FAIL = 'LIST_ORGS_FAIL';

export const GET_ORG_START = 'GET_ORG_START';
export const GET_ORG_SUCCESS = 'GET_ORG_SUCCESS';
export const GET_ORG_FAIL = 'GET_ORG_FAIL';

export const CREATE_ORG_START = 'CREATE_ORG_START';
export const CREATE_ORG_SUCCESS = 'CREATE_ORG_SUCCESS';
export const CREATE_ORG_FAIL = 'CREATE_ORG_FAIL';

export const UPDATE_ORG_START = 'UPDATE_ORG_START';
export const UPDATE_ORG_SUCCESS = 'UPDATE_ORG_SUCCESS';
export const UPDATE_ORG_FAIL = 'UPDATE_ORG_FAIL';

export const DELETE_ORG_START = 'DELETE_ORG_START';
export const DELETE_ORG_SUCCESS = 'DELETE_ORG_SUCCESS';
export const DELETE_ORG_FAIL = 'DELETE_ORG_FAIL';

export const CLEAR_ORG_UPDATE_STATE = 'CLEAR_ORG_UPDATE_STATE';
export const SET_ORG_TO_UPDATE = 'SET_ORG_TO_UPDATE';

// Recipients
export const CHECK_RECIPIENT_START = 'CHECK_RECIPIENT_START';
export const CHECK_RECIPIENT_SUCCESS = 'CHECK_RECIPIENT_SUCCESS';
export const CHECK_RECIPIENT_FAIL = 'CHECK_RECIPIENT_FAIL';

export const CREATE_RECIPIENT_START = 'CREATE_RECIPIENT_START';
export const CREATE_RECIPIENT_SUCCESS = 'CREATE_RECIPIENT_SUCCESS';
export const CREATE_RECIPIENT_FAIL = 'CREATE_RECIPIENT_FAIL';

export const LIST_RECIPIENTS_START = 'LIST_RECIPIENTS_START';
export const LIST_RECIPIENTS_SUCCESS = 'LIST_RECIPIENTS_SUCCESS';
export const LIST_RECIPIENTS_FAIL = 'LIST_RECIPIENTS_FAIL';

export const UPDATE_RECIPIENT_START = 'UPDATE_RECIPIENT_START';
export const UPDATE_RECIPIENT_SUCCESS = 'UPDATE_RECIPIENT_SUCCESS';
export const UPDATE_RECIPIENT_FAIL = 'UPDATE_RECIPIENT_FAIL';

export const DELETE_RECIPIENT_START = 'DELETE_RECIPIENT_START';
export const DELETE_RECIPIENT_SUCCESS = 'DELETE_RECIPIENT_SUCCESS';
export const DELETE_RECIPIENT_FAIL = 'DELETE_RECIPIENT_FAIL';

export const GET_RECIPIENT_START = 'GET_RECIPIENT_START';
export const GET_RECIPIENT_SUCCESS = 'GET_RECIPIENT_SUCCESS';
export const GET_RECIPIENT_FAIL = 'GET_RECIPIENT_FAIL';

export const GET_RECIPIENT_COUNT_START = 'GET_RECIPIENT_COUNT_START';
export const GET_RECIPIENT_COUNT_SUCCESS = 'GET_RECIPIENT_COUNT_SUCCESS';
export const GET_RECIPIENT_COUNT_FAIL = 'GET_RECIPIENT_COUNT_FAIL';

export const CLEAR_RECIP_UPDATE_STATE = 'CLEAR_RECIP_UPDATE_STATE';
export const SET_RECIP_TO_DELETE = 'SET_RECIP_TO_DELETE';

// Duplicates
export const GET_DUPLICATE_START = 'GET_DUPLICATE_START';
export const GET_DUPLICATE_SUCCESS = 'GET_DUPLICATE_SUCCESS';
export const GET_DUPLICATE_FAIL = 'GET_DUPLICATE_FAIL';

export const GET_DUPLICATE_INFO_START = 'GET_DUPLICATE_INFO_START';
export const GET_DUPLICATE_INFO_SUCCESS = 'GET_DUPLICATE_INFO_SUCCESS';
export const GET_DUPLICATE_INFO_FAIL = 'GET_DUPLICATE_INFO_START';

export const LIST_DUPLICATES_START = 'LIST_DUPLICATES_START';
export const LIST_DUPLICATES_SUCCESS = 'LIST_DUPLICATES_SUCCESS';
export const LIST_DUPLICATES_FAIL = 'LIST_DUPLICATES_FAIL';

export const UPDATE_DUPLICATE_START = 'UPDATE_DUPLICATE_START';
export const UPDATE_DUPLICATE_SUCCESS = 'UPDATE_DUPLICATE_SUCCESS';
export const UPDATE_DUPLICATE_FAIL = 'UPDATE_DUPLICATE_FAIL';

export const CLEAR_DUPLICATE_UPDATE_STATE = 'CLEAR_DUPLICATE_UPDATE_STATE';
export const SET_DUPLICATE_TO_RESOLVE = 'SET_DUPLICATE_TO_RESOLVE';
